import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from './firebase';
import { SellerAnalytics } from '../types';

export const getSellerAnalytics = async (sellerId: string): Promise<SellerAnalytics> => {
  try {
    // Get seller's artworks
    const artworksQuery = query(
      collection(db, 'artworks'),
      where('artistId', '==', sellerId)
    );
    const artworksSnapshot = await getDocs(artworksQuery);
    
    let totalViews = 0;
    let totalLikes = 0;
    
    artworksSnapshot.docs.forEach(doc => {
      const data = doc.data();
      totalViews += data.views || 0;
      totalLikes += data.likes || 0;
    });

    // Get seller's orders
    const ordersQuery = query(
      collection(db, 'orders'),
      where('sellerId', '==', sellerId)
    );
    const ordersSnapshot = await getDocs(ordersQuery);
    
    let totalRevenue = 0;
    let completedOrders = 0;
    let pendingOrders = 0;
    
    ordersSnapshot.docs.forEach(doc => {
      const data = doc.data();
      if (data.status === 'delivered') {
        totalRevenue += data.totalAmount || 0;
        completedOrders++;
      } else if (data.status === 'pending') {
        pendingOrders++;
      }
    });

    const conversionRate = totalViews > 0 ? (ordersSnapshot.size / totalViews) * 100 : 0;

    return {
      totalSales: ordersSnapshot.size,
      totalRevenue,
      pendingOrders,
      completedOrders,
      totalArtworks: artworksSnapshot.size,
      totalViews,
      totalLikes,
      conversionRate: parseFloat(conversionRate.toFixed(2)),
    };
  } catch (error) {
    console.error('Error getting seller analytics:', error);
    return {
      totalSales: 0,
      totalRevenue: 0,
      pendingOrders: 0,
      completedOrders: 0,
      totalArtworks: 0,
      totalViews: 0,
      totalLikes: 0,
      conversionRate: 0,
    };
  }
};